var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSignUpDialogIcon = function SvgSignUpDialogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#1F2E56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.003 25.884 30 29.882l7.997-3.998A2 2 0 0 0 36 24H24a2 2 0 0 0-1.997 1.884Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38 28.118-8 4-8-4V34a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5.882Z",
    fill: "#fff"
  })));
};

export default SvgSignUpDialogIcon;